import React, { useEffect } from "react";
import Sidebar from "./Sidebar";
import { theme, themeOptions, globalStyles, setNexGenThemeMode } from "../theme";

const SHELL_HEADER_HEIGHT = 88;

export default function PageLayout({ children, title, subtitle }) {
  useEffect(() => {
    const existing = document.getElementById("nexgen-global-styles");
    if (!existing) {
      const style = document.createElement("style");
      style.id = "nexgen-global-styles";
      style.textContent = globalStyles;
      document.head.appendChild(style);
    } else {
      existing.textContent = globalStyles;
    }
  }, []);

  const switchTheme = (mode) => {
    setNexGenThemeMode(mode);
    window.location.reload();
  };

  const shellSurface = theme.colors.sidebar || theme.colors.bg;

  return (
    <div style={{ display: "flex", height: "100vh", background: theme.colors.bg, overflow: "hidden" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: shellSurface }}>

        {/* Topbar */}
        <div style={{
          height: SHELL_HEADER_HEIGHT,
          borderBottom: `1px solid ${theme.colors.cardBorder}`,
          display: "flex", alignItems: "center", justifyContent: "space-between",
          marginLeft: -1,
          padding: "0 28px 0 29px",
          background: shellSurface,
          backdropFilter: "blur(10px)",
          flexShrink: 0,
          boxShadow: "none"
        }}>
          <div>
            <div style={{
              fontFamily: theme.fonts.display,
              fontSize: 16, fontWeight: 700,
              color: theme.colors.textPrimary, letterSpacing: 1
            }}>{title}</div>
            {subtitle && (
              <div style={{
                fontFamily: theme.fonts.mono,
                fontSize: 11,                        // +1 from before
                color: theme.colors.textLabel,       // brighter label color
                letterSpacing: 1.5, marginTop: 1
              }}>{subtitle}</div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <select
              value={theme.mode}
              onChange={e => switchTheme(e.target.value)}
              title="Select theme"
              style={{
                width: 128,
                padding: "7px 10px",
                background: theme.colors.inputBg,
                border: `1px solid ${theme.colors.cardBorder}`,
                borderRadius: 8,
                color: theme.colors.textSecondary,
                fontFamily: theme.fonts.mono,
                fontSize: 10,
                letterSpacing: 1,
                cursor: "pointer",
                outline: "none"
              }}
            >
              {themeOptions.map(option => (
                <option key={option.mode} value={option.mode}>{option.label}</option>
              ))}
            </select>
            <div style={{
              fontFamily: theme.fonts.mono, fontSize: 11,
              color: theme.colors.textSecondary        // brighter than before
            }}>
              {new Date().toLocaleString("en-US", {
                weekday: "short", month: "short", day: "numeric",
                hour: "2-digit", minute: "2-digit"
              })}
            </div>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: "auto", padding: "24px 28px", background: theme.colors.bg }}>
          {children}
        </div>
      </div>
    </div>
  );
}
